import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func centsToDollarString
 * @param {number} value - The amount in cents to be converted.
 * @return {string}
 * @desc Converts cents to dollars and formats as string without $ sign
 *```js
 * centsToDollarString(100);
 * // returns "1.00";
 *```
 * @memberof module:Number
 * @instance
 */
function centsToDollarString(value) {
    return checkTypeValidity(['number', 'numericalString'], value)
        ? (Number(value) / 100).toFixed(2)
        : null;
}

export { centsToDollarString as default };
